namespace StringUtility {
    export const clean = (str: string) => {
        if (str?.length) {
            return str;
        }

        return '';
    }

    export const uuid = (str: string) => {
        let value = clean(str);
        //this should ideally be done on the backend. To be removed once implemented from BE
        let regex = /(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/
        value = value.replace(regex, "$1-$2-$3-$4-$5")
        value = value.toLowerCase()
        return value;
    }

    const capitalize = (string = "") => {
        let res = ``;
        try {
            res = string?.charAt(0).toUpperCase() + string?.slice(1);
        } catch (error) {
            console.error("Error in capitalizeFirstLetter(). Error: ", error);
        }
        return res;
    }

    export const decodeCharFromHTMLEntity = (htmlChar: string) => {
        if (htmlChar && htmlChar?.length) {
            const tempElement = document.createElement('div');
            tempElement.innerHTML = htmlChar;
            const decodedChar = tempElement.textContent;
            tempElement.remove();
            return decodedChar;
        }

        return htmlChar;
    }

    export const formatFullName = (firstName: string, lastName: string) => {
        const name = capitalize(decodeCharFromHTMLEntity(firstName || ""));
        if(lastName?.length) {
            return `${name} ${decodeCharFromHTMLEntity(lastName).charAt(0).toUpperCase()}`
        }
        return name;
    };
}

export default StringUtility;